import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    FormControl,Typography, 
    InputLabel,
    Select,
    MenuItem,
    TablePagination,
    CircularProgress,
    Box,
} from "@mui/material";
import apiClient from "../utils/apiClient";

const ContactUsList = () => {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    // Filters
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState(""); // "true" | "false" | ""

    // Pagination
    const [page, setPage] = useState(0); // TablePagination is 0-based
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await apiClient.get("/api/news-letter/contact-us/all", {
                params: {
                    page: page + 1, // API is 1-based
                    limit: rowsPerPage,
                    search: search || undefined,
                    isSubscribed: status || undefined,
                },
            });

            setRows(res.data?.data?.contact || []);
            setTotal(res.data?.data?.total || 0);
        } catch (err) {
            console.error(err);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [page, rowsPerPage, search, status]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Paper sx={{ py: 4, px: 4 }}>
            <Typography variant="h5" gutterBottom>
                Contact Us Form List
            </Typography>
            {/* 🔹 Search & Filter */}
            <Box display="flex" gap={2} mb={2}>
                <TextField
                    label="Search "
                    variant="outlined"
                    size="small"
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value);
                        setPage(0); // reset page when searching
                    }}
                />

                {/* <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={status}
            label="Status"
            onChange={(e) => {
              setStatus(e.target.value);
              setPage(0);
            }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="true">Subscribed</MenuItem>
            <MenuItem value="false">Unsubscribed</MenuItem>
          </Select>
        </FormControl> */}
            </Box>

            {/* 🔹 Table */}
            <TableContainer component={Paper}>
                {loading ? (
                    <Box display="flex" justifyContent="center" p={3}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Message</TableCell>
                                <TableCell>Quantity</TableCell>
                                {/* <TableCell>Status</TableCell> */}
                                <TableCell>Created At</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.length > 0 ? (
                                rows.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{row.email}</TableCell>
                                        <TableCell>{row.phone}</TableCell>
                                        <TableCell>{row.message}</TableCell>
                                        <TableCell>{row.quantity}</TableCell>
                                        {/* <TableCell>
                      {row.isSubscribed ? "Subscribed" : "Unsubscribed"}
                    </TableCell> */}
                                        <TableCell>
                                            {new Date(row.createdAt).toLocaleDateString()}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        No records found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                )}
                {/* 🔹 Pagination */}
                <TablePagination
                    component="div"
                    count={total}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 25, 50]}
                />
            </TableContainer>

        </Paper>
    );
};

export default ContactUsList;
